<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">CONTENTS</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/6chap1#chap1">Book One Fortune’s Whirlwind</a></p>
<p class="toc2"><a href="#/Book1/7chap2#chap2">Chapter I - The Beating</a></p>
<p class="toc2"><a href="#/Book1/8chap3#chap3">Chapter II - Behind the Madonna</a></p>
<p class="toc2"><a href="#/Book1/9chap4#chap4">Chapter III - Blood in the Snow</a></p>
<p class="toc2"><a href="#/Book1/10chap5#chap5">Chapter IV - Kentland</a></p>
<p class="toc2"><a href="#/Book1/11chap6#chap6">Chapter V - A Game of Love</a></p>
<p class="toc2"><a href="#/Book1/12chap7#chap7">Chapter VI - “A Perfect Member of the Mob-ility”</a></p>
<p class="toc2"><a href="#/Book1/13chap8#chap8">Chapter VII - Brother Against Brother</a></p>
<p class="toc2"><a href="#/Book1/14chap9#chap9">Chapter VIII - Trap</a></p>
<p class="toc2"><a href="#/Book1/15chap10#chap10">Chapter IX - Flight</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/16chap11#chap11">Book Two The House of Sholto and Sons</a></p>
<p class="toc2"><a href="#/Book1/17chap12#chap12">Chapter I - Swords at St Paul’s</a></p>
<p class="toc2"><a href="#/Book1/18chap13#chap13">Chapter II - The Black Miracle</a></p>
<p class="toc2"><a href="#/Book1/19chap14#chap14">Chapter III - Mr. Burke and Dr. Franklin</a></p>
<p class="toc2"><a href="#/Book1/20chap15#chap15">Chapter IV - The Wizard of Craven Street</a></p>
<p class="toc2"><a href="#/Book1/21chap16#chap16">Chapter V - The One-Eyed Man</a></p>
<p class="toc2"><a href="#/Book1/22chap17#chap17">Chapter VI - The Bristol Coach</a></p>
<p class="toc2"><a href="#/Book1/23chap18#chap18">Chapter VII - To an Unknown Shore</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/24chap19#chap19">Book Three Liberty Tree</a></p>
<p class="toc2"><a href="#/Book1/25chap20#chap20">Chapter I - The Secret Room</a></p>
<p class="toc2"><a href="#/Book1/26chap21#chap21">Chapter II - Mistress Anne</a></p>
<p class="toc2"><a href="#/Book1/27chap22#chap22">Chapter III - September Fire</a></p>
<p class="toc2"><a href="#/Book1/28chap23#chap23">Chapter IV - Night of the Axe</a></p>
<p class="toc2"><a href="#/Book1/29chap24#chap24">Chapter V - Decision</a></p>
<p class="toc2"><a href="#/Book1/30chap25#chap25">Chapter VI - The Sergeant</a></p>
<p class="toc2"><a href="#/Book1/31chap26#chap26">Chapter VII - Betrayal</a></p>
<p class="toc2"><a href="#/Book1/32chap27#chap27">Chapter VIII - Journey to Darkness</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/33chap28#chap28">Book Four The Road From Concord Bridge</a></p>
<p class="toc2"><a href="#/Book1/34chap29#chap29">Chapter I - The Letter</a></p>
<p class="toc2"><a href="#/Book1/35chap30#chap30">Chapter II - A Death in Philadelphia</a></p>
<p class="toc2"><a href="#/Book1/36chap31#chap31">Chapter III - Alicia</a></p>
<p class="toc2"><a href="#/Book1/37chap32#chap32">Chapter IV - Too Much for the Whistle</a></p>
<p class="toc2"><a href="#/Book1/38chap33#chap33">Chapter V - Alarm at Midnight</a></p>
<p class="toc2"><a href="#/Book1/39chap34#chap34">Chapter VI - “God Damn It, They Are Firing Ball!”</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/Book1/40chap35#chap35">Afterword</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?6625c07a